// extracted by mini-css-extract-plugin
module.exports = {"price-loading":"plan-comparison_price-loading__fycUq","price-text":"plan-comparison_price-text__yP1e_"};